import { observer } from 'mobx-react-lite'
import type { ReactElement } from 'react'
import { AvailabilityWidget } from 'app/components/ai-agent-voice/AvailabilityWidget'
import { useAvailabilityLocation } from 'app/components/ai-agent-voice/useAvailabilityLocation'
import { AgentLocationPicker } from './AgentLocationPicker'
import { AgentsShell } from './AgentsShell'

/** Agents → Availability: the openings the voice agent can offer, one location at a time. */
export const AgentsAvailabilityPage = observer(function AgentsAvailabilityPage(): ReactElement {
  const { choices, locationId, isLoading, setLocationId } = useAvailabilityLocation()
  return (
    <AgentsShell
      actions={
        choices.length > 1 && <AgentLocationPicker options={choices} value={locationId} onChange={setLocationId} />
      }
    >
      <AvailabilityWidget locationId={locationId} isLoading={isLoading} />
    </AgentsShell>
  )
})
